export default "__VITE_ASSET__92551116__"